import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  LIVE_MAP_UI_DISPLAY_MODES,
  liveMapDisplayModeTranslationKey,
} from "@ryde/shared";

import { LiveMapDisplayModePreview } from "./live-map-display-mode.preview";
import { TUseLiveMapDisplayModeDropdown } from "./use-live-map-display-mode-dropdown";

interface ILiveMapDisplayModeDropdownArea {
  hookData: TUseLiveMapDisplayModeDropdown;
}

const POPOVER_Y_OFFSET = 10;

export const LiveMapDisplayModeDropdownArea: FC<
  ILiveMapDisplayModeDropdownArea
> = ({ hookData }) => {
  const { t } = useTranslation();
  const {
    anchorRef,
    closePopover,
    effectiveDisplayMode,
    handleItemClick,
    isPopoverOpen,
  } = hookData;

  return (
    <Popper
      open={isPopoverOpen}
      anchorEl={anchorRef.current}
      transition
      disablePortal
      placement="bottom-start"
      className="live-map-display-mode-popper"
      popperOptions={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, POPOVER_Y_OFFSET],
            },
          },
        ],
      }}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps}>
          <Paper elevation={8}>
            <ClickAwayListener onClickAway={closePopover}>
              <MenuList
                data-e2e="live-map-display-mode-dropdown-list"
                autoFocusItem
              >
                {LIVE_MAP_UI_DISPLAY_MODES.map(mode => (
                  <MenuItem
                    key={mode}
                    selected={effectiveDisplayMode === mode}
                    className="live-map-display-mode-dropdown-item"
                    onMouseDown={event => event.preventDefault()}
                    onClick={event => handleItemClick(event, mode)}
                  >
                    <LiveMapDisplayModePreview mode={mode} />
                    <span className="live-map-display-mode-dropdown-item__label">
                      {t(liveMapDisplayModeTranslationKey(mode))}
                    </span>
                  </MenuItem>
                ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
